<template>
  <div class="app-step-progress" :class="classList">
    <span
      >Step <b>{{ step }}</b> of <b>3</b></span
    >
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: () => 'light',
    },
    step: {
      type: String,
      default: () => '1',
    },
  },
  data() {
    return {
      themes: {
        light: 'theme-light',
        dark: 'theme-dark',
      },
    }
  },
  computed: {
    classList() {
      return this.themes[this.theme]
    },
  },
}
</script>

<style></style>
